import { EventSourcePolyfill } from 'event-source-polyfill';

export function findDocumentStorageByPg(text,isImage,productId) {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token');
    const encodedText = encodeURIComponent(text);
    let url = `${process.env.VUE_APP_API_URL}/api/aIApi/chat/?`
    if(isImage === true){
      url +=  `image=${encodedText}&prompt=` + encodeURIComponent('请解答图片中的题目')
    }else{
      url +=  `prompt=${encodedText}`
    }
    if(productId){
      url +=  `&productId=${productId}`
    }
    const eventSource = new EventSourcePolyfill(
        url,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    eventSource.onopen = () => {
      console.log("eventSource 已连接");
      resolve(eventSource);
    };

    eventSource.onerror = (error) => {
      console.error("eventSource 错误", error);
      if (error.status === 401) {
        reject(new Error('认证失败，请重新登录'));
      } else {
        reject(error);
      }
      eventSource.close();
    };

    eventSource.onclose = () => {
      console.log('SSE 连接已断开');
    };
  });
}
